import { Link } from "react-router-dom";
import { ArrowRight, Info } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { SERVICES, waLink } from "../config/site";

const NOTES = {
  "Visa Assistance":
    "Visa requirements, processing times and approvals depend on the relevant embassies and authorities. We guide you through requirements, documentation and the application process.",
  "Travel Insurance Assistance":
    "We help you explore suitable travel insurance options. Coverage, terms and any claim decisions rest with the insurance provider.",
};

export default function Services() {
  return (
    <div className="bg-sandlight pt-[72px]">
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
        <SectionHeading
          eyebrow="Travel Services"
          title="Eight Ways We Can Help"
          text="From flights and holidays to visas and corporate travel — every service begins with a simple enquiry, on WhatsApp or through our form."
        />

        <div className="mt-14 space-y-5">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.slug} delay={Math.min(i * 0.05, 0.3)}>
                <article
                  data-testid="service-card"
                  className="group flex flex-col gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-ocean/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-teal-900/10 sm:flex-row sm:items-center sm:p-8"
                >
                  <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-turquoise/10 text-turquoise transition-colors duration-300 group-hover:bg-ocean group-hover:text-gold">
                    <Icon className="h-8 w-8" />
                  </span>
                  <div className="flex-1">
                    <h2 className="font-display text-xl font-bold text-ink sm:text-2xl">{service.title}</h2>
                    <p className="mt-2 max-w-2xl text-sm leading-relaxed text-mutedink sm:text-base">
                      {service.description}
                    </p>
                    {NOTES[service.title] && (
                      <p className="mt-3 flex max-w-2xl items-start gap-2 rounded-xl bg-sand px-4 py-3 text-xs leading-relaxed text-ink/70">
                        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-coral" />
                        {NOTES[service.title]}
                      </p>
                    )}
                  </div>
                  <div className="flex shrink-0 flex-col gap-2 sm:items-end">
                    <a
                      href={waLink(`Hi ATO, I would like to enquire about ${service.title}.`)}
                      target="_blank" rel="noopener noreferrer"
                      data-testid={`service-enquire-${service.slug}`}
                      className="inline-flex items-center gap-2 rounded-full bg-coral px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#B01A23]"
                    >
                      Enquire Now <ArrowRight className="h-4 w-4" />
                    </a>
                    <Link
                      to={`/plan-your-trip?service=${encodeURIComponent(service.title)}`}
                      className="text-xs font-semibold text-turquoise hover:text-emeraldsea"
                    >
                      or use the enquiry form
                    </Link>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
